import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

export const ConsolidationInventoryItemSchema = z.object({
  id: inventoryItemIdFormat.schema,
  kind: z.string(),
  quantity: z.number(),
  available: z.number(),
  grade: z.string().nullable(),
  disposition: z.string().nullable(),
  storageLocationName: z.string().nullable(),
});

export type ConsolidationInventoryItem = z.infer<
  typeof ConsolidationInventoryItemSchema
>;

export const getConsolidationInventoryItems = {
  name: "getConsolidationInventoryItems" as const,
  input: z.object({
    merchantTeamId: z.string(),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ items: z.array(ConsolidationInventoryItemSchema) }),
};
